module.exports = function (arr) {
  var avg = Math.floor(arr.reduce(function (acc, val) {
    return acc + val;
  }) / arr.length * 100) / 100,
      min = arr.reduce(function (min, val) {
    return Math.min(min, val);
  }),
      max = arr.reduce(function (max, val) {
    return Math.max(max, val);
  }); // Deviation Calculation

  var difference = 0;
  arr.forEach(function (val) {
    return difference += Math.abs(val - avg);
  });
  var deviation = Math.floor(difference / avg * 100) / 100;
  return {
    avg: avg,
    min: min,
    max: max,
    deviation: deviation
  };
};